// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { AppRewardConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/AppReward';
import { DetailsRow } from '../../components/DetailsRow';
import PartyDisplay from '../../components/PartyDisplay';
import { DetailsLayout } from '../../components/Table/DetailsLayout';
import TemplateContract from '../../utils/TemplateContract';
import { fmt } from '../../utils/common';

interface AppRewardConfigDetailsProps {
  row?: TemplateContract<AppRewardConfiguration>;
}
const partyDisplay = (party: string) => <PartyDisplay party={party} />;
export const AppRewardConfigurationDetails: React.FC<AppRewardConfigDetailsProps> = ({ row }) => {
  if (!row) {
    return null;
  }
  const details = [
    {
      label: 'operator',
      value: partyDisplay(row.payload.operator),
    },
    {
      label: 'registrar',
      value: partyDisplay(row.payload.provider),
    },
    {
      label: 'dso',
      value: partyDisplay(row.payload.details.dso),
    },
    {
      label: 'beneficiary',
      value: partyDisplay(row.payload.details.operatorAppRewardBeneficiary.beneficiary),
    },
    {
      label: 'weight',
      value: fmt(row.payload.details.operatorAppRewardBeneficiary.weight, 2),
    },
  ];

  return (
    <DetailsLayout>
      {details.map((detail) => (
        <DetailsRow key={detail.label} value={detail.value} label={detail.label} />
      ))}
    </DetailsLayout>
  );
};
